<template>
  <div id="audioPlayerDiv">
    <input type="file" @change="handleFileChange" />
    <div>Current Time: {{ audioStore.currentTime }}</div>
    <div>Current Frame: {{ audioStore.currentTime * 60}}</div>
    <div>Duration: {{ audioStore.duration }}</div>
    <button @click="playAudio">Play</button>
    <button @click="pauseAudio">Pause</button>
    <input type="range" :max="audioStore.duration" :value="audioStore.currentTime" @input="seekAudio" />
    <p>Volume: <input type="range" step="0.01" max="1" @input="setVolume" /></p>
    <div>Playback rate: <input type="number" step="0.05" :value="audioStore.playbackRate" @input="setPlaybackRate" /></div>
    <button @click="unloadAudio">unload audio</button>
  </div>
</template>

<script setup>
import { useAudioStore } from '../../stores/AudioStore'
import { useIDBStore } from '../../stores/IDBStore'

const audioStore = useAudioStore()

const handleFileChange = (event) => {
  const file = (event.target).files?.[0]
  if (file) {
    audioStore.loadAudio(file)
    useIDBStore().setAudioDataItem(file.name, file)
  }
}

const playAudio = () => audioStore.play()
const pauseAudio = () => audioStore.pause()
const seekAudio = e => audioStore.seek(e.target.value)
const setVolume = e => audioStore.setVolume(e.target.value)
const setPlaybackRate = e => audioStore.setPlaybackRate(e.target.value)
const unloadAudio = () => audioStore.unloadAudio()


</script>
